import i18n from "i18next";

export interface UserPreference {
  key: string;
  userId: string;
  value: string;
}

export interface UserPreferences {
  language: OptionType | null;
  timeFormat: OptionType | null;
}

export enum UserPreferenceKey {
  language = "language",
  timeFormat = "timeFormat",
}

export const defaultUserPrefrences: UserPreferences = {
  language: null,
  timeFormat: null,
};

export type OptionType = {
  label: string;
  value: string;
};

export const languagesList: {} = {
  bg: "български (bg)",
  cs: "čeština (cs)",
  da: "dansk (da)",
  de: "Deutsch (de)",
  en: "English (en)",
  es: "Español (es)",
  fi: "Suomalainen (fi)",
  fr: "Français (fr)",
  gu: "ગુજરાત (gu)",
  hi: "हिंदी (hi)",
  hu: "Magyar (hu)",
  in: "bahasa Indonesia (in)",
  is: "Íslenskt (is)",
  it: "Italiano (it)",
  ja: "日本 (ja)",
  kn: "ಕನ್ನಡಿ (kn)",
  ko: "한국인 (ko)",
  ms: "Melayu (ms)",
  nl: "Nederlands (nl)",
  pl: "Polski (pl)",
  pt: "Português (pt)",
  ro: "Română (ro)",
  ru: "Русский (ru)",
  sk: "Slovenský (sk)",
  te: "తెలుగు (te)",
  th: "แบบไทย (th)",
  tl: "Tagalog (tl)",
  tr: "Türkçe (tr)",
  vi: "Tiếng Việt (vi)",
  zh: "中国人 (zh)",
};

export const getTimeFormatOptions = () => {
  return [
    { value: "12-hour", label: i18n.t("userPreferences_12_hour") },
    { value: "24-hour", label: i18n.t("userPreferences_24_hour") },
  ];
};
